import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { AdminLayout } from '../Components/Layout';
import PrivateRoute from './PrivateRoute';
import { useEffect } from 'react';
import { ChangePassword, Settings, CRPenaltyRequest } from '../Components/Admin/settings';
import ComponentPrint from '../Components/Admin/Common/ComponentPrint';
import Dashboard from '../Pages/Dashboard';
import Profile from '../Pages/Profile';
import Notification from '../Pages/Notification';
import { AddUser, EditUser, UserList } from '../Pages/UserManagement';
import { AddRole, EditRole, RoleList } from '../Pages/RoleManagement';
import { InsightsList, AddInsight, EditInsight } from '../Pages/Insights';
import { SubscriptionRequests } from '../Pages/SubscriptionRequests';
import { UserListing } from '../Pages/User';
import ViewUser from '../Pages/User/components/ViewUser';

const Logout = () => {
  const navigation = useNavigate();
  useEffect(() => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('adminPermission');
    navigation('/');
  }, [navigation]);
};
const AdminRoutes = () => {
  return (
    <React.Fragment>
      <AdminLayout />
      <Routes>
        <Route exact path='/' element={<PrivateRoute Component={Dashboard} />} />
        <Route exact path='/dashboard' element={<PrivateRoute Component={Dashboard} />} />
        <Route exact path='/users' element={<PrivateRoute Component={UserList} />} />
        <Route exact path='/add-user' element={<PrivateRoute Component={AddUser} />} />
        <Route exact path='/edit-user' element={<PrivateRoute Component={EditUser} />} />
        <Route exact path='/role' element={<PrivateRoute Component={RoleList} />} />
        <Route exact path='/add-role-management' element={<PrivateRoute Component={AddRole} />} />
        <Route exact path='/edit-role-permission' element={<PrivateRoute Component={EditRole} />} />
        <Route exact path='/view-booking' element={<PrivateRoute Component={ComponentPrint} />} />
        <Route exact path='/profile' element={<PrivateRoute Component={Profile} />} />
        <Route exact path='/notifications' element={<PrivateRoute Component={Notification} />} />
        <Route exact path='/setting' element={<PrivateRoute Component={Settings} />} />
        <Route exact path='/setting/change-password' element={<PrivateRoute Component={ChangePassword} />} />
        <Route exact path='/credit-request-penalty' element={<PrivateRoute Component={CRPenaltyRequest} />} />
        <Route exact path='/insight' element={<PrivateRoute Component={InsightsList} />} />
        <Route exact path='/add-insight' element={<PrivateRoute Component={AddInsight} />} />
        <Route exact path='/edit-insight' element={<PrivateRoute Component={EditInsight} />} />

        <Route exact path='subscription-requests' element={<PrivateRoute Component={SubscriptionRequests} />} />
        <Route exact path='user-listing' element={<PrivateRoute Component={UserListing} />} />
        <Route exact path='view-user' element={<PrivateRoute Component={ViewUser} />} />

        <Route exact path='/logout' element={<Logout />} />
      </Routes>
    </React.Fragment>
  );
};
export default AdminRoutes;
